import React from 'react'

const Policy = () => {
  return (
    <div className='container py-4'>
      <div className='bg-light p-4 rounded shadow-sm'>
        <h4 className='mb-3'>🚚 Shipping Policy</h4>
        <p>
          We are committed to timely delivery across India. All wellness kits
          are dispatched within 3–7 working days of order confirmation.
        </p>
        <p>
          No refunds or cancellations are allowed once the kit is delivered in
          sealed, packed condition. Delivery timelines may vary due to local
          conditions or courier delays.
        </p>
        <p>
          In case of loss or physical damage during transit, contact us within
          48 hours of delivery with supporting photos.
        </p>

        <h4 className='mt-4 mb-3'>📜 Terms & Conditions</h4>
        <p>
          Welcome to the Tesla Bird Wellness Platform. By using our website and
          services, you agree to the following:
        </p>
        <ul>
          <li>
            All content and tools are for educational and mental wellness
            purposes only.
          </li>
          <li>
            This platform does not substitute medical diagnosis or treatment.
          </li>
          <li>
            Users must not reproduce, share, or misuse our materials or
            branding.
          </li>
          <li>
            We reserve the right to update or modify services, content, or
            access without prior notice.
          </li>
          <li>Continued use implies acceptance of these terms.</li>
        </ul>

        <h4 className='mt-4 mb-3'>❌ Cancellation & Refund Policy</h4>
        <p>
          Orders once shipped and delivered in packed condition are
          non-refundable and non-cancellable.
        </p>
        <p>
          If you receive a wrong or damaged product, raise a request within 48
          hours of delivery.
        </p>
        <p>
          Replacement or refund decisions are at the sole discretion of Tesla
          Bird Wellness after verification.
        </p>

        <h4 className='mt-4 mb-3'>🔒 Privacy Policy</h4>
        <p>
          Your privacy matters to us. We collect only essential personal data
          (like name, contact info, delivery address) for order fulfillment and
          platform access.
        </p>
        <p>
          We do not sell, trade, or share your data with third parties without
          consent. All data is stored using industry-standard encryption and
          security.
        </p>
        <p>
          Usage of the Tesla Bird website implies agreement with our privacy
          practices.
        </p>
        <p>
          If you have any privacy-related concerns, please email us at
          <a href='mailto:info@teslabird.com'>info@teslabird.com</a>.
        </p>
      </div>
    </div>
  )
}

export default Policy
